import { useSelector } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ToolboxDetailHeader from "../ToolboxDetailHeader";
import FlowForm from "./components/FlowForm";
import Properties from "./components/Properties";
import Settings from "./components/Settings";
import Comments from "./components/Comments";
import TabPanel from "./components/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
import FlowConfiguration from "./components/FlowConfiguration";

const FlowProperties = () => {
   const { currentSavedFlow } = useSelector((state) => state.designer.flows);
   const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
   const { allowEditWorkflow } = useAllowEditWorkflow();
   const { t } = useTranslation("flowDesigner");
   const [tabValue, setTabValue] = useState(0);

   const handleChangeTab = (event, newValue) => {
      setTabValue(newValue);
   };

   return (
      <Box sx={{ flexGrow: 1, width: "100%", padding: "20px 15px 0 15px", height: "100%", minHeight: 0, display: "flex", flexDirection: "column", boxSizing: "border-box", overflow: "hidden" }}>
         <ToolboxDetailHeader title={t("toolbox.headers.flow_properties")} />
         <Box
            sx={{
               flex: 1,
               width: "100%",
               p: 0,
               display: "flex",
               flexDirection: "column",
               height: "100%",
               minHeight: 0,
               overflow: "hidden"
            }}
         >
            <Tabs
               value={tabValue}
               variant="scrollable"
               orientation="horizontal"
               scrollButtons="auto"
               onChange={handleChangeTab}
               sx={{ minHeight: "40px", background: "transparent !important" }}
            >
               <Tab label={t("buttons.properties")} />
               <Tab label={t("common.flow_configuration")} />
               <Tab label={t("common.settings")} />
               <Tab label={t("common.comments")} />
            </Tabs>
            {tabValue !== 1 && tabValue !== 3 && (
               <FlowForm allowEditWorkflow={allowEditWorkflow(isReadOnlyAccess)}>
                  <TabPanel value={tabValue} index={0}>
                     <Properties />
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                     <Settings />
                  </TabPanel>
               </FlowForm>
            )}
            <TabPanel value={tabValue} index={1}>
               <FlowConfiguration currentSavedFlow={currentSavedFlow} allowEditWorkflow={allowEditWorkflow(isReadOnlyAccess)} />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
               <Comments tabValue={tabValue} />
            </TabPanel>
         </Box>
      </Box>
   );
};

export default FlowProperties;
